var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseModalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "close_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.39995 18.3L5.69995 17.6L11.3 12L5.69995 6.40001L6.39995 5.70001L12 11.3L17.6 5.70001L18.3 6.40001L12.7 12L18.3 17.6L17.6 18.3L12 12.7L6.39995 18.3Z",
    fill: "#525252"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseModalIcon);
export default __webpack_public_path__ + "static/media/close-modal-icon.e4706829267b2d29f7282d3003090c91.svg";
export { ForwardRef as ReactComponent };